import Paper from 'components/ui/Paper';
import React from 'react';

const MarketSentiment = ({ marketCap }) => {
    const marketData = [
        {
            title: 'Fusce convallis, nibh at commodo',
            description: 'Pellentesque varius est nec elit auctor, accumsan cursus ipsum sit amet massa sit ...',
            buttonLabel: 'Read More',
            buttonColor: '#006CFF',
        },
        {
            title: 'Fusce convallis, nibh at commodo',
            description: 'Pellentesque varius est nec elit auctor, accumsan cursus ipsum sit amet massa sit ...',
            buttonLabel: 'Read More',
            buttonColor: '#006CFF',
        },
    ];

    return (
        <Paper>
            <div className="text-xl font-bold mb-4">Market Sentiment</div>
            <div className='flex flex-col sm:flex-row gap-6'>
                {marketData.map((data, index) => (
                    <Paper key={index} className="shadow-xl flex flex-col gap-4">
                        <div className='text-[#2B3674] text-xl font-bold'>{data.title}</div>
                        <div className='text-[#A3AED0] text-sm font-semibold'>{data.description}</div>
                        <div className='flex justify-between gap-2'>
                            <div>img</div>
                            <div className={`rounded-lg w-fit bg-[${data.buttonColor}] text-white px-5 py-1 cursor-pointer`}>
                                {data.buttonLabel}
                            </div>
                        </div>
                    </Paper>
                ))}
            </div>
        </Paper>
    );
};

export default MarketSentiment;
